<script>
import options from './DeliveryCard.options'
export default options
</script>

<template>

    <div class="kb-delivery-card" :class="{ 'kb-delivery-card--chosen': isChosenDelivery }">

        <div class="kb-delivery-card__content-top">
            <div class="kb-delivery-card__icon-title-wrapper">
                <div class="kb-delivery-card__icon-circle" v-html="svgIcon"></div>
                <p class="kb-delivery-card__title">{{ getLabel('title') }}</p>
            </div>
            <template v-if="!isShippingFree">
                <p class="kb-delivery-card__price">{{ getLabel('price') }}</p>
            </template>
        </div>

        <div class="kb-delivery-card__content-bottom"
            :class="{ 'kb-delivery-card__content-bottom--faded': showDifferentAddress }">

            <template v-if="type === 'home'">
                <div class="kb-delivery-card__address">
                    <p>{{ invoiceAddress.addressLine }}</p>
                    <p>{{ invoiceAddress.postalCode }}</p>
                    <p>{{ invoiceAddress.city }}</p>
                    <button @click="handleShowDifferentAddress" class="kb-delivery-card__link">
                      {{ getLabel('differentAddressText') }}
                    </button>
                </div>
            </template>

            <template v-if="type === 'pickUp'">
                <p class="kb-delivery-card__text">{{ getLabel('text') }}</p>
            </template>

            <button @click="handleChosenDelivery" class="kb-button kb-button--spot-border-color">
                {{ isChosenDelivery ? getLabel('buttonTitlePicked') : getLabel('buttonTitlePick') }}
                <template v-if="isChosenDelivery">
                    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 13.304 10.5 18 18 6" stroke="#3C3C3C" stroke-linejoin="round" />
                    </svg>
                </template>
            </button>
        </div>


    </div>

</template>